import { defineSlotRecipe } from "@pandacss/dev";
import { progressAnatomy } from "@ark-ui/react";

const Height = {
  small: "4px",
  big: "8px",
};

export const aromaLoader = defineSlotRecipe({
  className: "aroma-loader",
  jsx: ["Loader"],
  slots: progressAnatomy.keys(),
  base: {
    track: {
      background: "background.neutral.base.subtle",
      height: Height.small,
      borderRadius: "pill",
      width: "200px",
      overflow: "hidden",
    },
    range: {
      height: Height.small,
      position: "relative",
      borderRadius: "pill",
      _before: {
        content: "''",
        borderRadius: "pill",
        background: "background.brand.bold",
        display: "block",
        position: "absolute",
        width: "20%",
        height: Height.small,
        top: 0,
        left: 0,
        animation: "horizontalLoader 2400ms infinite linear",
      },
    },
    label: {
      textStyle: "paragraph.m.regular",
      color: "content.neutral.base.subtlest",
    },
  },
  variants: {
    size: {
      small: {
        track: {
          height: Height.small,
        },
        range: {
          height: Height.small,
          _before: {
            height: Height.small,
          },
        },
      },
      medium: {
        track: {
          height: Height.big,
        },
        range: {
          height: Height.big,
          _before: {
            height: Height.big,
          },
        },
      },
    },
    fullWidth: {
      true: {
        track: {
          width: "100%",
        },
      },
    },
  },
  defaultVariants: {
    size: "small",
    fullWidth: false,
  },
});
